"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getSuccessStatus(successStatus) {
    switch (successStatus) {
        case 'pass':
            return entity_1.SuccessStatus.PASS;
        case 'fail':
            return entity_1.SuccessStatus.FAIL;
        case 'na':
        default:
            return entity_1.SuccessStatus.NOT_APPLICABLE;
    }
}
exports.getSuccessStatus = getSuccessStatus;
//# sourceMappingURL=getSuccessStatus.js.map